<div class="container column">
    <ng-content></ng-content>
</div>
